document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('hoverGallery');
  if (!container) return;

  const grid = container.querySelector('section.hover-gallery__grid');

  const items = container.querySelectorAll('section.hover-gallery__grid .hover-gallery__item');
  items.forEach((el, index) => {
    const i = index + 1;
    if (i % 1 === 0) el.classList.add('down');
    if (i % 2 === 0) el.classList.add('up');
    if (i % 4 === 0) el.classList.add('img-custom');
  });

  const imgContainers = grid.querySelectorAll('.hover-gallery__img-container');
  imgContainers.forEach(item => {
    item.style.transition = 'transform 0.8s ease';

    item.addEventListener('mouseenter', () => {
      item.style.transform = 'scale(120%)';
      imgContainers.forEach(other => {
        if (other !== item) {
          other.querySelector('.hover-gallery__cover').style.opacity = '1';
        }
      });
    });

    item.addEventListener('mouseleave', () => {
      item.style.transform = 'scale(1)';
      imgContainers.forEach(other => {
        other.querySelector('.hover-gallery__cover').style.opacity = '0';
      });
    });
  });

  let aimX = 0.5;
  let aimY = 0.5;
  let currentX = 0.5;
  let currentY = 0.5;

  const move = (x, y) => {
    const rect = container.getBoundingClientRect();
    aimX = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
    aimY = Math.max(0, Math.min(1, (y - rect.top) / rect.height));
  };

  const tween = () => {
    currentX = currentX + (aimX - currentX) * 0.07;
    currentY = currentY + (aimY - currentY) * 0.07;

    const sx = grid.clientWidth - container.getBoundingClientRect().width;
    const sy = grid.clientHeight - container.getBoundingClientRect().height;

    grid.style.transform = `translate(${-sx * currentX}px, ${-sy * currentY}px)`;
    requestAnimationFrame(tween);
  };
  tween();

  container.addEventListener('mousemove', (e) => move(e.clientX, e.clientY));

  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));
  let lastTouch = null;

  container.addEventListener('touchstart', (e) => {
    if (e.touches.length === 1) {
      const t = e.touches[0];
      lastTouch = { x: t.clientX, y: t.clientY };
    }
  }, { passive: true });

  container.addEventListener('touchmove', (e) => {
    if (!lastTouch || e.touches.length !== 1) return;

    const t = e.touches[0];
    const dx = t.clientX - lastTouch.x;
    const dy = t.clientY - lastTouch.y;

    const isAtTop = aimY <= 0 && dy > 0;
    const isAtBottom = aimY >= 1 && dy < 0;

    if (isAtTop || isAtBottom) return;

    e.preventDefault();

    aimX = clamp(aimX - dx / container.clientWidth);
    aimY = clamp(aimY - dy / container.clientHeight);

    lastTouch = { x: t.clientX, y: t.clientY };
  }, { passive: false });

  container.addEventListener('touchend', () => {
    lastTouch = null;
  });
});
